import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const formatDateDDMMYYYY = () => {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${d.getFullYear()}`;
};

export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export async function exportJsonToExcel(rows, filename, sheetName = "Export") {
  if (!Array.isArray(rows) || rows.length === 0) return;
  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet(sheetName);
  const headers = Object.keys(rows[0]);

  ws.addRow(headers);
  ws.getRow(1).font = { bold: true };
  ws.getRow(1).alignment = { vertical: "middle" };

  rows.forEach((r) => {
    ws.addRow(headers.map((h) => (r[h] == null ? "" : r[h])));
  });

  headers.forEach((h, idx) => {
    const col = ws.getColumn(idx + 1);
    let max = Math.max(String(h).length, 10);
    col.eachCell({ includeEmpty: true }, (cell) => {
      const v = cell.value == null ? "" : String(cell.value);
      max = Math.max(max, v.length);
    });
    col.width = Math.min(Math.max(max + 2, 10), 45);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  downloadBlob(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename
  );
}

export function exportRowsToCsv(rows, filename) {
  if (!Array.isArray(rows) || rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const escape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [
    headers.map(escape).join(","),
    ...rows.map((row) => headers.map((h) => escape(row[h])).join(",")),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  downloadBlob(blob, filename);
}

export function exportRowsToPdf(rows, filename, options = {}) {
  if (!Array.isArray(rows) || rows.length === 0) return;
  const {
    orientation = "landscape",
    fontSize = 7,
    margin = { top: 12, left: 8, right: 8 },
  } = options;
  const headers = Object.keys(rows[0]);
  const body = rows.map((row) => headers.map((h) => row[h]));
  const doc = new jsPDF(orientation);
  autoTable(doc, {
    head: [headers],
    body,
    styles: { fontSize, cellPadding: 2 },
    headStyles: { fillColor: [245, 247, 251], textColor: [45, 47, 51] },
    margin,
  });
  doc.save(filename);
}
